module.exports = __webpack_public_path__ + "static/media/success.0b3f79fb.wav";